module.exports = __webpack_public_path__ + "static/media/website-11.0a7859d5.png";